<template>
  <div class="drug-info-wrapper">
    <div class="title">{{ title }}</div>
    <transition-group
      name="list"
      tag="div"
      @before-enter="beforeEnter"
      @enter="enter"
      @afterEnter="afterEnter"
      @before-leave="beforeLeave"
      @leave="leave"
      @after-leave="afterLeave"
    >
      <drug-info-card
        :ref="`card${card.id}`"
        :key="card.id"
        v-for="(card, i) in drugInfoList"
        :info="card"
        :index="i"
        @add="addDrug"
        :options="options"
        :drugInfoList="drugInfoList"
        :drugWarn="drugWarn[card.name]"
      />
    </transition-group>
    <el-button plain class="btn-add-drug button--larger" @click="addDrug">
      {{ drugInfoList.length > 0 ? '+继续添加' : '+添加药品' }}
    </el-button>
    <transition name="zoom-in-top">
      <div v-if="showError" class="error">药品未添加</div>
    </transition>
  </div>
</template>

<script>
import drugInfoCard from './drugInfoCard';
import { CARD_MODE, ACTION_TYPE } from '../../constants';

export default {
  name: 'drugInfo',
  components: {
    drugInfoCard
  },
  props: {
    title: {
      type: String,
      default: '2.药品信息'
    },
    drugInfoList: {
      type: Array,
      default: () => []
    },
    showError: Boolean,
    options: Object,
    drugWarn: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  inject: [ACTION_TYPE.ADD_DRUG_INFO],
  methods: {
    beforeEnter(el) {
      // 给元素设置过渡效果
      el.style.transition = '0.5s all ease-in-out';
      // 高度变化时，让其内容隐藏
      el.style.overflow = 'hidden';
      el.style.opacity = 0;
      el.style.transform = 'translateZ(0)';
    },
    enter(el) {
      el.style.height = 'auto';
      // 保存元素原来的高度
      const endHeight = window.getComputedStyle(el).height;
      el.style.height = '0px';
      // 强制浏览器回流，否则浏览器会合并两次元素的高度更改（回流重绘的知识）
      el.offsetHeight;
      el.style.height = endHeight;
      el.style.opacity = 1;
    },
    afterEnter(el) {
      // el.style.height = null;
      // 收尾工作，展示完过渡效果之后，设为原来的值
      el.style.transition = '';
      el.style.overflow = 'visible';
      el.style.height = 'auto';
    },
    beforeLeave(el) {
      // 给元素设置过渡效果
      el.style.transition = '0.5s all ease-in-out';
      // 高度变化时，让其内容隐藏
      el.style.overflow = 'hidden';
      el.style.opacity = 1;
      el.style.transform = 'translateZ(0)';
    },
    leave(el) {
      el.style.height = 'auto';
      // 设置高度为具体的值
      el.style.height = window.getComputedStyle(el).height;
      // 强制浏览器回流，否则浏览器会合并两次元素的高度更改（回流重绘的知识）
      el.offsetHeight;
      el.style.height = '0px';
      el.style.opacity = 0;
    },
    afterLeave(el) {
      el.style.transition = '';
      el.style.overflow = 'visible';
      this.$emit('refreshDrugInfo');
    },
    addDrug() {
      this[ACTION_TYPE.ADD_DRUG_INFO]({ mode: CARD_MODE.NEW, id: +new Date() });
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-info-wrapper {
  position: relative;
  margin-bottom: 30px;

  .title {
    margin-bottom: 11px;
    color: #242424;
    font-size: 16px;
    font-weight: bold;
  }

  .btn-add-drug {
    margin-top: 10px;
    color: #1e8dff;
    border-color: #1e8dff;
  }

  .error {
    position: absolute;
    top: 100%;
    left: 0;
    font-size: 12px;
    color: #eb3c36;
  }

  .zoom-in-top-enter-active,
  .zoom-in-top-leave-active {
    opacity: 1;
    transform: scaleY(1);
    transition: all 300ms cubic-bezier(0.23, 1, 0.32, 1);
    transform-origin: center top;
  }
  .zoom-in-top-enter,
  .zoom-in-top-leave-active {
    opacity: 0;
    transform: scaleY(0);
  }

  //.list-enter-active,
  //.list-leave-active {
  //  transition: all 0.5s;
  //  transition-delay: 0.3s;
  //  /deep/.transition-wrapper {
  //    transition: all 0.5s ease-in-out;
  //  }
  //}
  //.list-enter {
  //  /deep/.transition-wrapper {
  //    opacity: 0;
  //    transform: translateY(-30%);
  //  }
  //}
  //.list-leave-to {
  //  max-height: 0;
  //  /deep/.transition-wrapper {
  //    opacity: 0;
  //    transform: translateY(-30%);
  //  }
  //}
}
</style>
